<template>
  <div>
  <div :id="'myTokenAnalytics'" :style="{width: '100%', height: '400px'}" :class="nodataFlag?'hidden':'show'"></div>
    <div v-if="nodataFlag" class="nodata">{{$t('analytics.nodata')}}</div>
  </div>
</template>
<script>
import { Line } from "vue-chartjs";

export default {
  name: "LineChart",
  extends: Line,
  props: ["date", "csCount", "txCount", "depositTxCount", "withdrawTxCount", "depositAddressCount", "withdrawAddressCount", "addressCount"],
  data() {
    return {
      yAxisShowFlag1: true,
      yAxisShowFlag2: true,
      yAxisShowFlag3: true,
      dataFlag1: true,
      dataFlag2: true,
      dataFlag3: true,
      dataFlag4: true,
      myChart: "",
      option: {},
      nodataFlag: false
    };
  },
  mounted() {
    let self = this;
      if (this.txCount.length !== 0) {
        this.nodataFlag = false;
        this.drawLine();
      }else{
        this.clear()
      }
    /* self.drawLine(); */
  },
  watch: {
    txCount: function() {
      if (this.txCount.length !== 0) {
        this.nodataFlag = false;
        this.drawLine();
      }else{
        this.nodataFlag = true;
        this.clear()
      }
    }
  },
  methods: {
    drawLine() {
      // 基于准备好的dom，初始化echarts实例
      /* console.log(this.txCount) */
      this.myChart = this.$echarts.init(document.getElementById("myTokenAnalytics"));
      // 绘制图表
      this.option = {
        color:["#000","#609a224d","#609A22","#1067BB","#0000004d","#609a224d","#1069bc4d"],
        title: { text: this.label },
        tooltip: {
          trigger: "axis",
          confine:true,
          position: function(pt) {
            return [pt[0], "10%"];
          },
          padding: 0,
          axisPointer: {
            lineStyle: {
              width: 1,
              color: "#0000001a"
            }
          },
          backgroundColor: "#fff",
          textStyle: {
            color: "#F7B500"
          },
          formatter: function(params) {
            /* console.log(params) */
            var res = "";
            if (params.length > 0) {
              res =
                res +
                "<h2 class='tooltips-title' style='font-size:16px;padding-bottom:40px'>" +
                params[0].axisValueLabel +
                "</h2>";

              for (var i = 0; i < params.length; i++) {
                res =
                  res +
                  "<div style='display:flex;justify-content: space-between;'>" +
                  "<div style='display:flex;'>" +
                  "<div style='transform: translateY(7px);margin-right:5px;width:10px;height:10px;padding-top:4px;border-radius: 5px;background-color:"+
                  params[i].color+
                  "'>" +
                  "</div>" +
                  params[i].seriesName +
                  "</div><div>" +
                  params[i].data[1] +
                  "</div>" +
                  "</div>";
              }
              res = "<div class='tooltips-container'>" + res + "</div>";
              return res;
            } else {
              return;
            }
          }
        },
        grid: {
          right: 100,
          bottom: 100,
          left:35
        },
        dataZoom: [
          {
            type: "inside",
            start: 0,
            end: 100,
            bottom: 50
          },
          {
            type: "inside",
            start: 0,
            end: 100,
          },
        ],
        legend: {
          /* data: ["余额", "交易数", "去重转入地址数", "去重转出地址数"], */
          left: 0,
          color:["#000","#609a224d","#609A22","#1067BB","#0000004d","#609a224d","#1069bc4d"],
          icon: "rect",
          align:"left",
          itemWidth: 12,
          itemHeight: 8,
        },
        xAxis: {
          axisPointer: {
            show: true
          },
            axisLine:{
              show:false
            },
             axisTick:{
               show:false
             },
            splitLine:{
              show:false
            },
            axisLabel:{
              interval:7,
              fontSize:10,
              showMaxLabel:true,
              showMinLabel:false,
              color:'rgba(0, 0, 0, 0.6)'
            },
          type: "time"
          /*           axisLabel:{
             formatter:function(value){
               return value.substr(8,3)+value.substr(15,2)
             }
          } */
        },
        yAxis: [
          {
            id: 1,
            position: "left",
            axisLine:{
              show:false
            },
             axisTick:{
               show:false
             },
            splitLine:{
              show:false
            },
            show: true,
            axisLabel: {
              fontSize:10,
              interval:5,
              showMinLabel:false,
              color:'rgba(0, 0, 0, 0.6)',
              formatter: function(value, index) {
                if (value > 1000000 || value < -1000000) {
                  return value / 1000000 + "m";
                } else {
                  if (value > 1000 || value < -1000) {
                    return value / 1000 + "k";
                  } else {
                    return value;
                  }
                }
              }
            }
          },
          {
            name: this.$t('analytics.contracts'),
            nameTextStyle:{
              fontSize:10,
              color:'rgba(0, 0, 0, 0.6)'
            },
            position: "right",
            splitNumber: 10, // Y 轴分隔格数
            type: "value",
            show: true,
            nameLocation: "center",
            nameGap: 30,
            axisLine:{
              show:false
            },
             axisTick:{
               show:false
             },
            splitLine:{
              show:false
            },
            axisLabel: {
              fontSize:10,
              interval:5,
              showMinLabel:false,
              color:'rgba(0, 0, 0, 0.6)',
              formatter: function(value, index) {
                if (value > 1000000) {
                  return value / 1000000 + "m";
                } else {
                  if (value > 1000) {
                    return value / 1000 + "k";
                  } else {
                    return value;
                  }
                }
              }
            }
          }
        ],
        series: [
          {
            id:0,
            smooth:true,
            smoothMonotone:'x',
            name: this.$t('analytics.txnCount'),
            type: "line",
            symbol: "none",
            lineStyle:{
              width:1.2, 
            },
            itemStyle: {
              normal: {
                /* 线条颜色 */
                lineStyle: {
                  color: "#000"
                }
              }
            },
            data: this.txCount
          },
          {
            id:3,
            smooth:true,
            smoothMonotone:'x',
            name: this.$t('analytics.uniqueOutAddress'),
            type: "line",
            yAxisIndex: 0,
            symbol: "none",
            lineStyle:{
              width:1.2, 
            },
            itemStyle: {
              normal: {
                /* 线条颜色 */
                lineStyle: {
                  color: "#609a224d"
                }
              }
            },
            data: this.withdrawAddressCount
          },
          {
            id:4,
            smooth:true,
            smoothMonotone:'x',
            name: this.$t('analytics.uniqueinAddress'),
            type: "line",
            yAxisIndex: 0,
            symbol: "none",
            lineStyle:{
              width:1.2, 
            },
            itemStyle: {
              normal: {
                /* 线条颜色 */
                lineStyle: {
                  color: "#609A22"
                }
              }
            },
            data: this.depositAddressCount
          },
          {
            id:5,
            smooth:true,
            smoothMonotone:'x',
            name: this.$t('analytics.uniqueAddress'),
            type: "line",
            yAxisIndex: 0,
            symbol: "none",
            lineStyle:{
              width:1.2, 
            },
            itemStyle: {
              normal: {
                /* 线条颜色 */
                lineStyle: {
                  color: "#1067BB"
                }
              }
            },
            data: this.addressCount
          },
          {
            id:6,
            smooth:true,
            smoothMonotone:'x',
            name: this.$t('analytics.contracts'),
            type: "line",
            yAxisIndex: 1,
            symbol: "none",
            lineStyle:{
              width:1.2, 
            },
            itemStyle: {
              normal: {
                /* 线条颜色 */
                lineStyle: {
                  color: "#0000004d"
                }
              }
            },
            data: this.csCount
          }
        ]
      };
      this.myChart.setOption(this.option);
    },
    clear(){
      this.myChart = this.$echarts.init(
        document.getElementById("myTokenAnalytics")
      );
      this.myChart.clear()
    }
  }
};
</script>
<style lang="less">
.tooltips-container {
  padding: 20px;
}
#myTokenAnalytics {
  padding-top: 50px;
  .tooltips-container {
    box-shadow: 0px 20px 40px 0px rgba(0, 0, 0, 0.1) !important;
    border-radius: 10px !important;
    padding: 20px !important;
    min-width: 280px;
  }
}

.tooltips-title {
  color: #000 !important;
}
.hidden {
  display: none;
}
.show {
  display: block;
}
.nodata {
  padding-top: 40px;
  font-size: 16px;
  line-height: 20px;
  font-family: Avenir-Medium, Avenir;
}
</style>



// WEBPACK FOOTER //
// src/components/common/contractTokenAnalytics.vue